// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".problem-tabs[data-v-503f8ffb]{border:.5px solid #ececec;border-radius:.5rem;padding-top:16px}", ""]);
// Exports
module.exports = exports;
